<template>
	<v-form @submit.prevent="submit">
		<v-text-field
			v-model.trim="$v.formData.email.$model"
			outlined
			dense
			filled
			solo
			label="Email"
			hint="Ej: correo@correo.cl"
			:error-messages="emailErrors"
			@input="$v.formData.email.$touch()"
			@blur="$v.formData.email.$touch()"
		></v-text-field>
		<v-btn block text small :loading="loading" color="primary" type="submit">
			Compartir
		</v-btn>
	</v-form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, maxLength, required, email } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
	name: 'SharingForm',
	mixins: [validationMixin],
	data() {
		return {
			formData: { email: '' },
			loading: false,
		};
	},
	computed: {
		emailErrors() {
			const errors = [];
			if (!this.$v.formData.email.$dirty) return errors;
			!this.$v.formData.email.required && errors.push('Campo requerido');
			!this.$v.formData.email.minLength && errors.push('Minimo 3 Caracteres');
			!this.$v.formData.email.maxLength && errors.push('Maximo 50 Caracteres');
			!this.$v.formData.email.email && errors.push('Escriba un correo electrónico válido');
			return errors;
		},
	},
	validations: {
		formData: {
			email: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(100),
				email,
			},
		},
	},
	methods: {
		async submit() {
			this.$v.$touch();

			if (!this.$v.$invalid) {
				this.loading = true;
				await this.sharePlaceAndPersons(this.formData);
			}
			this.resetForm();
			this.loading = false;
		},
		resetForm() {
			this.formData = { email: '' };
			this.$v.$reset();
		},
		...mapActions({
			sharePlaceAndPersons: 'User/sharePlaceAndPersons',
		}),
	},
};
</script>

<style scoped></style>
